import { createUseStyles, ComposedTheme } from '@glu/theming';

const styles = ({ spacing: { unit } }: ComposedTheme) => ({
  content: {
    padding: [10 * unit, 5 * unit, 0, 0]
  },
  takeover: {
    padding: 0,
    '& > [class*="header"]': {
      position: 'fixed',
      right: 3 * unit,
      top: 2 * unit
    }
  }
});

export default createUseStyles(styles);
